<template>
  <Container class="container--main">
    <h1 class="title">Recuperar tu cuenta</h1>
    <!-- <div class="card">
      <b>Recuerda que: </b>Los datos y/ o información del presente servicio se basan en la Resolución Ministerial Nº 355-2018-VIVIENDA
      y en la Ley Nº 27806, Ley de Transparencia y Acceso a la Información Pública.
    </div> -->
    <form action="form" class="form" @submit.prevent="recoverUser">
      <div class="msg__successful" v-if="successful">¡{{ successful }}!</div>
      <label class="form-label" for="email"
        >Correo electrónico<span class="camp_required">*</span>:</label
      >
      <input
        v-model="email"
        class="form-input"
        type="email"
        id="email"
        required
        placeholder="Ingrese su correo electrónico"
      />

      <Button class="btn__submit" tag="button" type="submit" theme="primary">
        Recuperar contraseña
      </Button>

      <ul class="errores_msg" v-if="errorList">
        <li>{{ errorList }}.</li>
      </ul>
    </form>
  </Container>
</template>

<script>
import axios from "axios";
import Button from "@/components/ui/atoms/Button.vue";
import Container from "@/components/ui/objects/Container";

export default {
  components: {
    Button,
    Container,
  },
  data() {
    return {
      email: "",
      errorList: null,
      successful: null,
    };
  },
  methods: {
    recoverUser() {
      axios
        .post(
          `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/recuperacion-contrasena/send-email`,
          {
            email: this.email,
          }
        )
        .then((response) => {
          if (response.data.msg.includes("satisfactoriamente")) {
            this.successful = response.data.msg;
          }
        })
        .catch((error) => {
          this.errorList = error.response.data.errors;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";

.title {
  text-align: center;
  color: variables.$primary-color;
}
.form {
  margin: 1rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  min-width: 350px;
  max-width: 100%;
  border-radius: 5px;
}
.form-label {
  margin-top: 2rem;
  color: variables.$primary-color;
  margin-bottom: 0.5rem;
  &:first-of-type {
    margin-top: 0rem;
  }
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid variables.$primary-color;
  color: rgb(95, 95, 95);
  &:focus {
    outline: 0;
    border: 2px solid variables.$primary-color;
  }
}

.errores_msg li {
  color: red;
}
.camp_required {
  color: rgb(180, 12, 12);
}

.btn__submit {
  margin-top: 2rem;
}
.msg__successful {
  text-align: center;
  border: 1px solid green;
  border-radius: 0.2rem;
  padding: 1rem 0;
  margin-bottom: 2rem;
  background: #9fdbc2;
  color: rgb(0, 65, 35);
  font-size: 1.2rem;
}
</style>
